import {MAB_SECTION_MAP} from '../constants/layout';

export function parseMabResponse(response) {
    try {
        const {order} = response;
        return order
            .sort(
                (firstEl, secondEl) =>
                    parseInt(firstEl.categoryName, 10) - parseInt(secondEl.categoryName, 10)
            )
            .map((arm) => MAB_SECTION_MAP[arm.level.replace('_module', '')]);
    } catch (e) {
        return [];
    }
}

// Helper function that generates the final layout object used by LayoutManager
export function generateLayoutOrder(sectionsOrder, sectionsConfig) {
    return sectionsOrder.reduce((order, section) => {
        if (section && sectionsConfig[section]) {
            order.push({
                name: section,
                ...sectionsConfig[section]
            });
        }

        return order;
    }, []);
}
